import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

interface UpdateBigQueryAsteraPayload {
  filters: {
    identifier: string;
  };
  update_data: {
    covermymed_id: string;
    response_status: string;
    pa_outcome_classification: string;
    route_via: string;
    comments?: string;
    poc?: string;
    second_stp_status?: string;
  };
  org_id: string;
  request_id: string;
}

export const updateBigQueryDataAstera = async (
  payload: UpdateBigQueryAsteraPayload,
) => {
  try {
    const token = await getBearerToken();
    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.UPDATE_BIGQUERY_DATA, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating BigQuery data for Astera:", error);
    throw error;
  }
};
